import React from 'react';
import { Link, useNavigate } from 'react-router';

import {
    FaEye,
    FaEdit,
    FaTrash,
} from 'react-icons/fa';
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../redux/features/modalSlice";
import Pagination from '../../common/Pagination';
import SearchBar from '../../common/Search';
import { setBlog } from '../../redux/features/filtersSlice';
import { useGetBlogQuery } from "../../redux/services/blogService/blog.Services";
function Allblog() {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const filters = useSelector((state) => state.filters.Blog);
    const { data, isLoading, isError } = useGetBlogQuery(filters);
    const BlogData = data?.data || [];
    const pagination = data?.pagination || {};
    const totalPages = pagination?.totalPages || 0;
    const showPagination = totalPages > 1;
    const isActive = (status) => {
        return String(status).toLowerCase() === "active";
    };
    const handlePageChange = (page) => {
        dispatch(
            setBlog({
                page,
            })
        );

    };
    const handleSearch = (value) => {

        dispatch(
            setBlog({
                search: value,
                page: 1,
            })
        );

    };

    if (isLoading) {
        return <h3>Loading...</h3>;
    }

    if (isError) {
        return <h3>Something Went Wrong</h3>;
    }


    return (
        <div>

            {/* PAGE HEADER */}
            <div className="page-header-breadcrumb all_breadcrumb">

                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">

                    <nav>

                        <h4 className="fw-semibold">
                            All Blogs
                        </h4>

                        <ol className="breadcrumb mb-0">

                            <li className="breadcrumb-item">
                                <Link to="/">
                                    Home
                                </Link>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                All Blogs
                            </li>

                        </ol>

                    </nav>

                </div>

                <div className="page-title fw-semibold fs-18 mb-0">

                    <Link
                        to="/add-blog"
                        className="btn btn-primary"
                    >
                        Add Blog
                    </Link>

                </div>
                <div className="mb-3">

                    <SearchBar
                        search={filters.search}
                        setSearch={handleSearch}
                        placeholder="Search Blog..."
                    />

                </div>
            </div>

            {/* TABLE CARD */}
            <div className="st-wrapper-card">

                <div className="st-table-responsive">

                    <table className="table st-custom-table align-middle mb-0">

                        <thead>

                            <tr>
                                <th>ID</th>
                                <th>Image</th>
                                <th>Blog</th>
                                <th>Category</th>
                                <th>Author</th>
                                <th>Date</th>
                                <th> Change Status</th>
                                <th>Status</th>
                                <th className="text-center">
                                    Action
                                </th>
                            </tr>

                        </thead>
                        <tbody>
                            {
                                BlogData.map((item, index) => (
                                    <tr key={item._id || item.id}>
                                        <td>
                                            {(index + 1) + ((filters.page - 1) * filters.limit)
                                            }
                                        </td>
                                        <td>
                                            <div className="blogimage"><img
                                                src={`${data?.imageBaseUrl}${item.image}`}
                                                alt={item.title}
                                                width="50"
                                                height="50"
                                                style={{
                                                    objectFit: "cover",
                                                    borderRadius: "8px"
                                                }}
                                            /><img src={item.blogimage} width={50} alt={item.blogimage} />
                                            </div>
                                        </td>
                                        <td>

                                            <div className="blog-info-box">


                                                <div>

                                                    <h6>
                                                       {item.name}
                                                    </h6>

                                                </div>

                                            </div>

                                        </td>

                                        {/* CATEGORY */}
                                        <td>
                                            {item.category_name}
                                        </td>

                                        {/* AUTHOR */}
                                        <td>
                                            {item.author}
                                        </td>

                                        {/* DATE */}
                                        <td>
                                            {
                                                new Date(item.created_at)
                                                    .toLocaleDateString()
                                            }
                                        </td>
                                        <td style={{ width: "150px" }}>

                                            <div className="city-status-switch">

                                                <input
                                                    type="checkbox"

                                                    id={`status-${item._id || item.id}`}

                                                    className="city-status-input"

                                                    checked={isActive(item.status)}

                                                    onChange={() =>
                                                        dispatch(
                                                            openModal({
                                                                type: "status-blog",

                                                                title: "Change Blog Status",

                                                                data: {
                                                                    id: item._id || item.id,

                                                                    name: item.title,

                                                                    status: item.status,

                                                                    apiUrl: "/blog-status",

                                                                    message:
                                                                        `You want to change status of ${item.title}`,
                                                                },
                                                            })
                                                        )
                                                    }
                                                />

                                                <label
                                                    htmlFor={`status-${item._id || item.id}`}
                                                    className="city-status-label"
                                                >

                                                    <span className="city-status-ball"></span>

                                                    <span className="city-status-text">

                                                        {
                                                            isActive(item.status)
                                                                ? "Active"
                                                                : "Inactive"
                                                        }

                                                    </span>

                                                </label>

                                            </div>

                                        </td>
                                        {/* STATUS */}
                                        <td>

                                            <span
                                                className={
                                                    isActive(item.status)
                                                        ? 'blog-status published'
                                                        : 'blog-status draft'
                                                }
                                            >

                                                {
                                                    isActive(item.status)
                                                        ? "Active"
                                                        : "Inactive"
                                                }

                                            </span>

                                        </td>

                                        {/* ACTION */}
                                        <td className="text-center">

                                            {/* VIEW */}
                                            <button
                                                className="st-action-btn st-view-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "view-blog",
                                                            title: "Blog Details",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEye />
                                            </button>

                                            {/* EDIT */}
                                            <button
                                                className="st-action-btn st-edit-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "edit-blog",
                                                            title: "Edit Blog",
                                                            data: item,
                                                        })
                                                    )
                                                }
                                            >
                                                <FaEdit />
                                            </button>

                                            {/* DELETE */}
                                            <button
                                                className="st-action-btn st-delete-btn"
                                                onClick={() =>
                                                    dispatch(
                                                        openModal({
                                                            type: "delete-blog",
                                                            title: "Delete Blog",
                                                            data: {
                                                                id: item._id || item.id,
                                                                apiUrl: "/blog-delete",
                                                                message: `You are deleting ${item.title}`,
                                                            },
                                                        })
                                                    )
                                                }
                                            >
                                                <FaTrash />
                                            </button>

                                        </td>

                                    </tr>

                                ))
                            }

                        </tbody>

                    </table>
                    <div className="d-flex justify-content-end mt-4">

                        {
                            showPagination && (

                                <Pagination
                                    page={filters.page}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />

                            )
                        }

                    </div>
                </div>

            </div>



        </div>
    );
}

export default Allblog; 